import { isObject } from '@mui/x-data-grid/internals';
import { useAtomValue } from 'jotai';

import sessionAtom, { sessionStore } from '~atoms/sessionAtom';
import { pagePaths } from '~constants';
// Explicitly not from barrel to prevent circular dependencies.
import UsersService from '~features/users/services/usersService';
import User from '~interfaces/user';
import { getService } from '~services/serviceFactory';

const usersService = getService(UsersService);

let isUpdatingUser = false;

const useSession = () => {
	const session = useAtomValue(sessionAtom);
	const isMock = import.meta.env?.VITE_DEV_MOCK_API === true;

	if (
		!isUpdatingUser &&
		session.hasValidSession &&
		(!isObject(session.user) || session.user == undefined)
	) {
		isUpdatingUser = true;
		usersService
			.getCurrentUser()
			.then((user) => {
				sessionStore.setConnectUser(user);
				isUpdatingUser = false;
			})
			.catch((_apiError) => {
				sessionStore.clear();
				window.location.assign(pagePaths.AuthLogin);
			});
	}

	return {
		isMock: isMock,
		user: session.user,
		hasValidSession: session.hasValidSession,
		expiresAt: session.expiresAt,
		expiresIn: session.expiresIn,
		isLoading: session.isLoading,
		bypassLoader: session.bypassLoader,
		updateSessionUser: (user: User) => {
			sessionStore.setConnectUser(user);
		},
	};
};

export default useSession;
